<script>
import Header from './Header.vue';
import ScrollToTop from './ScrollToTop.vue';
export default {
  components: {
    'header-component': Header,
    ScrollToTop
  },
  data() {
    return {
      showFilters: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    toggleCheck(event) {
      const checkbox = event.target.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
      }
    },
    handleScroll: function () {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },


    /* VIDEOS */
    playVideo(url, title) {
      let video = document.getElementById("playVideos");
      let videoTitle = document.getElementById("video-title");

      video.src = url;
      videoTitle.innerHTML = title;
      //video.play();
      //video.focus();


    },
    openVideo() {
      let video = document.getElementById("playVideos");
      let videoOverlay = document.getElementById('video-overlay');
      let videoWrap = document.getElementById('video-wrapper');

      if (videoWrap.style.display == "none") {
        videoWrap.style.display = "inline-block";
        videoOverlay.style.display = "block";
      }
    },
    closeVideo() {
      let video = document.getElementById("playVideos");
      let videoOverlay = document.getElementById('video-overlay');
      let videoWrap = document.getElementById('video-wrapper');

      if (videoWrap.style.display == "inline-block") {
        videoWrap.style.display = "none";
        videoOverlay.style.display = "none";
        video.src = "";
        //video.pause();
      }
    },

    applyFilters() {
      let caregiversCb = document.getElementById('ResourceCaregivers');
      let patientsCb = document.getElementById('ResourcePatients');
      let tteamCb = document.getElementById('ResourcesTTeam');
      let laisCb = document.getElementById('ResourcesLais');
      let listItem = document.getElementsByClassName("list-item");
      let checkedLength = jQuery('.filter-list input:checked').length;

      jQuery(".list-item").each(function () {
        jQuery(this).hide();
        jQuery(this).removeClass('active');
      });

      jQuery(".caregivers").hide();
      jQuery(".patients").hide();
      jQuery(".tteam").hide();
      jQuery(".lais").hide();
      jQuery(".applied-label").hide();

      if (checkedLength == 1) {
        //ONE
        if (caregiversCb.checked == true) {
          jQuery(".list-item").each(function () {
            let getEl = jQuery(this);
            if (jQuery(this).attr('data-filter4') != '') {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".caregivers").show();

          this.showEmptyMessage();
        }

        if (patientsCb.checked == true) {
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            if (jQuery(this).attr('data-filter3') != '') {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".patients").show();

          this.showEmptyMessage();
        }

        if (tteamCb.checked == true) {
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            if (jQuery(this).attr('data-filter1') != '') {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".tteam").show();

          this.showEmptyMessage();
        }

        if (laisCb.checked == true) {
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            if (jQuery(this).attr('data-filter2') != '') {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".lais").show();

          this.showEmptyMessage();
        }
      }


      if (checkedLength == 2) {
        // TWO
        // caregivers +
        if ((caregiversCb.checked == true) && (patientsCb.checked == true)) {
          jQuery(".list-item.active").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active');
            if ((getEl.attr('data-filter4') != '') && (getEl.attr('data-filter3') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".caregivers").show();
          jQuery(".patients").show();

          this.showEmptyMessage();
        }

        if ((caregiversCb.checked == true) && (tteamCb.checked == true)) {
          jQuery(".list-item.active").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active');
            if ((getEl.attr('data-filter4') != '') && (getEl.attr('data-filter1') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".caregivers").show();
          jQuery(".tteam").show();

          this.showEmptyMessage();
        }

        if ((caregiversCb.checked == true) && (laisCb.checked == true)) {
          jQuery(".list-item.active").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active')
            if ((getEl.attr('data-filter4') != '') && (getEl.attr('data-filter2') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".caregivers").show();
          jQuery(".lais").show();

          this.showEmptyMessage();
        }

        // patients +
        if ((patientsCb.checked == true) && (tteamCb.checked == true)) {
          jQuery(".list-item.active").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active')
            if ((getEl.attr('data-filter3') != '') && (getEl.attr('data-filter1') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".patients").show();
          jQuery(".tteam").show();

          this.showEmptyMessage();
        }

        if ((patientsCb.checked == true) && (laisCb.checked == true)) {
          jQuery(".list-item.active").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active')
            if ((getEl.attr('data-filter3') != '') && (getEl.attr('data-filter2') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".patients").show();
          jQuery(".lais").show();

          this.showEmptyMessage();
        }
        // tteam +
        if ((tteamCb.checked == true) && (laisCb.checked == true)) {
          jQuery(".list-item.active").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active');
            if ((getEl.attr('data-filter1') != '') && (getEl.attr('data-filter2') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".tteam").show();
          jQuery(".lais").show();

          this.showEmptyMessage();
        }
      }

      if (checkedLength == 3) {
        // THREE
        // caregivers +
        if ((caregiversCb.checked == true) && (patientsCb.checked == true) && (tteamCb.checked == true)) {
          jQuery(".list-item").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active');
            if ((getEl.attr('data-filter4') != '') && (getEl.attr('data-filter3') != '') && (getEl.attr('data-filter1') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".caregivers").show();
          jQuery(".patients").show();
          jQuery(".tteam").show();

          this.showEmptyMessage();
        }

        if ((caregiversCb.checked == true) && (patientsCb.checked == true) && (laisCb.checked == true)) {
          jQuery(".list-item.active").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active');
            if ((getEl.attr('data-filter4') != '') && (getEl.attr('data-filter3') != '') && (getEl.attr('data-filter2') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".caregivers").show();
          jQuery(".patients").show();
          jQuery(".lais").show();

          this.showEmptyMessage();
        }

        if ((caregiversCb.checked == true) && (tteamCb.checked == true) && (laisCb.checked == true)) {
          jQuery(".list-item").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active');
            if ((getEl.attr('data-filter4') != '') && (getEl.attr('data-filter1') != '') && (getEl.attr('data-filter2') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".caregivers").show();
          jQuery(".tteam").show();
          jQuery(".lais").show();

          this.showEmptyMessage();
        }

        // patients +
        if ((patientsCb.checked == true) && (tteamCb.checked == true) && (laisCb.checked == true)) {
          jQuery(".list-item").hide();
          jQuery(".list-item").each(function () {
            var getEl = jQuery(this);
            getEl.removeClass('active');
            if ((getEl.attr('data-filter3') != '') && (getEl.attr('data-filter1') != '') && (getEl.attr('data-filter2') != '')) {
              getEl.addClass('active');
              jQuery(".list-item.active").show();
            }
          });
          jQuery(".patients").show();
          jQuery(".tteam").show();
          jQuery(".lais").show();

          this.showEmptyMessage();
        }
      }


      // NONE
      if ((caregiversCb.checked == false) && (patientsCb.checked == false) && (tteamCb.checked == false) && (laisCb.checked == false)) {
        jQuery(".list-item").show();
        jQuery(".list-item").each(function () {
          var getEl = jQuery(this);
          getEl.show();
          getEl.removeClass('active');
        });
        jQuery(".caregivers").hide();
        jQuery(".patients").hide();
        jQuery(".tteam").hide();
        jQuery(".lais").hide();
        jQuery(".applied-label").show();
        jQuery(".empty-message").remove();
      }

      if (checkedLength == 4) {
        if ((caregiversCb.checked == true) && (patientsCb.checked == true) && (tteamCb.checked == true) && (laisCb.checked == true)) {
          jQuery(".caregivers").show();
          jQuery(".patients").show();
          jQuery(".tteam").show();
          jQuery(".lais").show();
          jQuery(".applied-label").hide();

          this.showEmptyMessage();
        }
      }


      jQuery("#filter-ckeck").prop("checked", false);

    },

    showEmptyMessage() {
      let getActiveQty = jQuery(".list-item.active").length;
      let emptyMessage = "<div class='empty-message' style='width:80%;'>No resources match the selected combination of categories.</div>";

      jQuery(".empty-message").remove();
      if (getActiveQty > 0) {
        jQuery(".empty-message").remove();
      }

      if (getActiveQty === 0) {
        jQuery(".list-wrap").prepend(emptyMessage);
      }
    },

    remodeCaregiversLabel() {
      jQuery(this).prop("checked", false);
      jQuery("#ResourceCaregivers").prop("checked", false);
      this.applyFilters();
    },
    remodePatientsLabel() {
      jQuery(this).prop("checked", false);
      jQuery("#ResourcePatients").prop("checked", false);
      this.applyFilters();
    },
    remodeTteamLabel() {
      jQuery(this).prop("checked", false);
      jQuery("#ResourcesTTeam").prop("checked", false);
      this.applyFilters();
    },
    remodeLaisLabel() {
      jQuery(this).prop("checked", false);
      jQuery("#ResourcesLais").prop("checked", false);
      this.applyFilters();
    },


  },

}
</script>

<template>
  <div role="main">
    <div class="top-wrap">
      <div class="top-content">
        <div class="top-banner">
          <header-component></header-component>
          <h1>Resource Library</h1>
        </div>
      </div>

    </div>

    <div class="list-content">

      <div class="filters-wrap">
        <button class="filter-button" id="filters" @click="toggleFilters">
          <img src="../img/filter-down.png" alt="Filter Resources By" />
          <span>FILTER RESOURCES BY</span>
        </button>

          <div class="filter-content" id="filter-content" v-show="showFilters">
            <div class="filter-head">
              CATEGORY
            </div>
            <div class="filter-list">
              <p><input type="checkbox" id="ResourceCaregivers" /> <label for="ResourceCaregivers">Resources for
                  Caregivers</label></p>
              <p><input type="checkbox" id="ResourcePatients" /> <label for="ResourcePatients">Resources for
                  Patients</label></p>
              <p><input type="checkbox" id="ResourcesTTeam" /> <label for="ResourcesTTeam">Resources for the Treatment
                  Team</label></p>
              <p><input type="checkbox" id="ResourcesLais" /> <label for="ResourcesLais">Resources to Address Barriers to
                  LAIs</label></p>
            </div>
            <button id="apply" @click="applyFilters();">
              <div class="apply">APPLY</div>
            </button>
          </div>
      </div>

      <div class="applied-filters">
        <div class="applied-label">Showing categories: <span>ALL</span></div>
        <div class="applied-filters-list">
          <div class="caregivers" style="display: none;">
            <input type="checkbox" id="caregivers" @click="remodeCaregiversLabel();" />
            <label for="caregivers">Resources for Caregivers</label>
          </div>
          <div class="patients" style="display: none;">
            <input type="checkbox" id="patients" @click="remodePatientsLabel();" />
            <label for="patients">Resources for Patients</label>
          </div>
          <div class="tteam" style="display: none;">
            <input type="checkbox" id="tteam" @click="remodeTteamLabel();" />
            <label for="tteam">Resources for the Treatment Team</label>
          </div>
          <div class="lais" style="display: none;">
            <input type="checkbox" id="lais" @click="remodeLaisLabel();" />
            <label for="lais">Resources to Address Barriers to LAIs</label>
          </div>
        </div>
      </div>

      <div class="list-wrap">


        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="pdf-icon">Population Identification Methods</div>
          <p>Learn about population identification methods you can use with your own data to understand distinct
            subgroups (eg, nonadherent patients, high utilizers) that might be appropriate for treatment with LAI
            therapy. </p>
          <a href="/static/files/cp-179676v2_Appropriate_Population_Identification_Methods.pdf" target="_blank"
            aria-label="Download Population Identification Methods PDF" class="button download">DOWNLOAD <img src="../img/down-icon.png"
              alt="" /></a>
        </div>
        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="xls-icon">Population Identification Worksheet </div>
          <p>Worksheet to help you identify appropriate patients within your population for treatment with LAI therapy.
          </p>
          <a href="/static/files/cp-179677v2_Appropriate_Population_Identification_Worksheet.xlsx" aria-label="Download Population Identification Worksheet"
            target="_blank" class="button download">DOWNLOAD <img src="../img/down-icon.png" alt="" /></a>
        </div>




        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="web-icon">The State of Schizophrenia</div>
          <p>Tune in to a discussion with clinicians about the stigma and burden of schizophrenia.</p>
          <a href="https://talkinglais.com/reducing-series-ep1" target="_blank" aria-label="Visit The State of Schizophrenia website"
            class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="web-icon" data-filter="patients">The Cost of Repeated Relapse</div>
          <p>Hear what a panel of clinicians says about the consequences of repeated relapse in adult patients with
            schizophrenia, such as loss of work.</p>
          <a href="https://talkinglais.com/reducing-series-ep2" target="_blank" aria-label="Visit The Cost of Repeated Relapse website"
            class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="web-icon">Benefits of LAI Intervention</div>
          <p>Listen to a discussion with clinicians about biases and outcomes when evaluating treatment with LAI
            intervention for adult patients with schizophrenia.</p>
          <a href="https://talkinglais.com/reducing-series-ep3" target="_blank" aria-label="Visit Benefits of LAI Intervention website"
            class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>

        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="web-icon">Why Are LAIs Underutilized?</div>
          <p>Attend a broadcast of clinicians detailing why treatment with LAIs is underutilized (eg, stigma, lack of
            awareness, or access) in adult patients with schizophrenia.</p>
          <a href="https://talkinglais.com/reducing-series-ep4" target="_blank" aria-label="Visit Why Are LAIs Underutilized website"
            class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="web-icon">Improving How HCPs Offer Patients LAIs</div>
          <p>Learn how practicing clinicians proactively approach the conversation around treatment with LAIs with adult
            patients with schizophrenia.</p>
          <a href="https://talkinglais.com/reducing-series-ep5" target="_blank" aria-label="Visit Improving How HCPs Offer Patients LAIs website"
            class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="web-icon">Importance of the Therapeutic Alliance</div>
          <p>Understand how to overcome potential roadblocks to treatment with LAIs and the importance of the
            Therapeutic Alliance and caregiver engagement.</p>
          <a href="https://talkinglais.com/reducing-series-ep6" target="_blank" aria-label="Visit Importance of the Therapeutic Alliance website"
            class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>

        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="web-icon">Shared Decision Making and LAIs</div>
          <p>Discuss the shared decision-making process and considerations for successful dialogue around treatment with
            LAIs.</p>
          <a href="https://talkinglais.com/reducing-series-ep7" aria-label="Visit Shared Decision Making and LAIs website" target="_blank"
            class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>

        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="ResourcesLais" data-filter3=""
          data-filter4="">
          <div class="no-icon">Facilitating the Discussion on LAIs</div>
          <p>Through mock conversations, learn how team members can discuss LAI treatment with an adult patient with
            schizophrenia.</p>
          <div class="video-thumb" tabindex="0" role="button" aria-label="Facilitating the Discussion on LAIs"
            @click="playVideo('https://players.brightcove.net/4317630935001/default_default/index.html?videoId=6266522890001', 'Facilitating the Discussion on LAIs'); openVideo();"
            @keydown.enter.prevent="playVideo('https://players.brightcove.net/4317630935001/default_default/index.html?videoId=6266522890001', 'Facilitating the Discussion on LAIs'); openVideo();"
            @keydown.space.prevent="playVideo('https://players.brightcove.net/4317630935001/default_default/index.html?videoId=6266522890001', 'Facilitating the Discussion on LAIs'); openVideo();">
            <img src="../img/Facilitating_the_Discussion_on_LAIs.png"
              alt="Facilitating the Discussion on Long-Acting Injectable Antipsychotics" />
          </div>
        </div>

        <div class="list-item" data-filter1="ResourcesTTeam" data-filter2="" data-filter3="" data-filter4="">
          <div class="web-icon">How to Give LAIs</div>
          <p>A review for nurses and other psychiatric healthcare professionals about how to give LAI intramuscular
            injections.</p>
          <a href="https://www.janssenmd.com/intramuscularinjections" aria-label="Visit How to Give LAIs website" target="_blank"
            class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>

        <div class="list-item" data-filter1="" data-filter2="ResourcesLais" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="pdf-icon">Goal Setting</div>
          <p>Information and exercises to help patients build goal-setting skills.</p>
          <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-54209v6.pdf" target="_blank"
            class="button download" aria-label="Download Goal Setting PDF">DOWNLOAD <img src="../img/down-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="" data-filter2="ResourcesLais" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="pdf-icon">Problem Solving</div>
          <p>Help patients identify challenges related to achieving treatment goals and to find solutions through
            informative exercises.</p>
          <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-55401v7.pdf" target="_blank"
            class="button download" aria-label="Download Problem Solving PDF">DOWNLOAD <img src="../img/down-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="" data-filter2="ResourcesLais" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="pdf-icon">Making Choices</div>
          <p>Informative document to help patients make decisions that are right for them.</p>
          <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-54300v7.pdf" target="_blank" aria-label="Download Making Choices PDF"
            class="button download">DOWNLOAD <img src="../img/down-icon.png" alt="" /></a>
        </div>

        <div class="list-item" data-filter1="" data-filter2="ResourcesLais" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="pdf-icon">Partners in Care</div>
          <p>Assist patients with getting loved ones involved in their recovery journeys.</p>
          <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-53757v7.pdf" target="_blank" aria-label="Download Partners in Care PDF"
            class="button download">DOWNLOAD <img src="../img/down-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="" data-filter2="ResourcesLais" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="pdf-icon">Explore Your Beliefs</div>
          <p>Get patients to think about their personal beliefs when it comes to their medications.</p>
          <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-110941v4.pdf" target="_blank" aria-label="Download Explore Your Beliefs PDF"
            class="button download">DOWNLOAD <img src="../img/down-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="" data-filter2="ResourcesLais" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="pdf-icon">Making Decisions Together</div>
          <p>Assistance to help patients become active partners in their treatment and recovery.</p>
          <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-63642v7.pdf" target="_blank" aria-label="Download Making Decisions Together PDF"
            class="button download">DOWNLOAD <img src="../img/down-icon.png" alt="" /></a>
        </div>

        <div class="list-item" data-filter1="" data-filter2="ResourcesLais" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="pdf-icon">Making Medication Decisions</div>
          <p>Support patients to begin conversations with their treatment teams about their preferences.</p>
          <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-110940v4.pdf" target="_blank" aria-label="Download Making Medication Decisions PDF"
            class="button download">DOWNLOAD <img src="../img/down-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="" data-filter2="ResourcesLais" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="pdf-icon">Treatment and Recovery Log</div>
          <p>Patients can keep track of their medication preferences and recovery histories with this helpful resource.
          </p>
          <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-25171v7.pdf" target="_blank" aria-label="Download Treatment and Recovery Log PDF"
            class="button download">DOWNLOAD <img src="../img/down-icon.png" alt="" /></a>
        </div>
        <div class="list-item" data-filter1="" data-filter2="" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="web-icon">Schizophrenia Education</div>
          <p>Videos for adult patients with schizophrenia to better understand their schizophrenia diagnosis, treatment
            options (including outpatient treatment), symptoms, and myths versus facts.</p>
          <a href="https://www.hopeforschizophrenia.com/what-is-schizophrenia/" target="_blank" aria-label="Visit Schizophrenia Education website"
            class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>


        <div class="list-item" data-filter1="" data-filter2="" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="web-icon">Caregiver Education</div>
          <p>Videos to support caregivers on topics such as practical tips, the importance of self-care, and how to
            support a loved one living with schizophrenia.</p>
          <a href="https://www.hopeforschizophrenia.com/caring-for-your-loved-one/" aria-label="Visit Caregiver Education website"
            target="_blank" class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>

        <div class="list-item" data-filter1="" data-filter2="" data-filter3="ResourcePatients"
          data-filter4="ResourceCaregivers">
          <div class="web-icon">Understanding Supportive Therapies</div>
          <p>Learn about supportive therapy options such as cognitive behavioral therapy, counseling, and Certified Peer
            Support Specialists through short videos. Scroll toward the bottom of the website page to find the
            resources. </p>
          <a href="https://www.hopeforschizophrenia.com/schizophrenia-therapies/" aria-label="Visit Understanding Supportive Therapies website"
            target="_blank" class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt="" /></a>
        </div>



      </div>
      <div class="applied-filters">
        <div class="LAI-text">LAI=long-acting injectable antipsychotic</div>
      </div>
      <ScrollToTop />


      <div class="video-wrapper video-closed" id="video-wrapper" style="display:none;">
        <div class="video-close" id="video-close" @click="closeVideo();">X</div>
        <div class="video-title" id="video-title">Video Title</div>
        <iframe id="playVideos" src="" allowfullscreen="" allow="encrypted-media"
          style="top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 90%;"></iframe>
        <!--<video id="playVideos" controls disablePictureInPicture>
              <source id="playVideosss"  type="video/mp4">
            </video>-->
      </div>
      <div id="video-overlay" class="overlay" @click="closeVideo();"></div>
    </div>

  </div>

</template>

<style scoped>
#app>div {
  width: 100%;
}

/*TOP */

.top-wrap {
  background: rgb(0, 18, 82);
  background: linear-gradient(0deg, rgba(0, 18, 82, 1) 0%, rgba(0, 70, 126, 1) 50%, rgba(0, 70, 126, 1) 100%);
  color: #ffffff;
  padding-bottom: 55px;
  width: 100%;
}

.top-content {
  background: linear-gradient(to top, #0079A8, #0084B8);
  border-radius: 0 0 0 100px;
  margin-left: 3%;
  padding-bottom: 50px;
  width: 97%;
}

.top-banner {
  background: url(../img/banner-bg.png) no-repeat 0 0;
  background-size: cover;
  border-radius: 0 0 0 100px;
  min-height: 367px;
  margin-left: 1.5%;
  width: 98.5%;
}

.top-banner h1 {
  display: block;
  font-family: Gotham, sans-serif;
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  margin: 68px auto 20px auto;
  text-align: center;
}

.top-banner h2 {
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 22px;
  font-style: italic;
  font-weight: 100;
  margin: 0 auto;
  text-align: center;
  width: 650px;
}

.top-banner sup {
  font-size: 11px;
  font-weight: 400;
  margin: 0 0 0 2px;
  vertical-align: text-top;
}

.top-banner section {
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  margin: 40px auto 0 auto;
  text-align: center;
  width: 1040px;
}

.top-content p.banner-footer {
  font-family: "GothamBook", sans-serif;
  font-size: 24px;
  text-align: center;
}

.bottom-banner {
  color: #00a0df;
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 70px auto 0 auto;
  text-align: left;
  width: 1120px;
}

.bottom-banner-text {
  color: #ffffff;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.bottom-banner-text sup {
  font-size: 11px;
  font-weight: 400;
  position: relative;
  top: -0.2em;
  vertical-align: top;
}

.list-content {
  background: #eeeef3;
  margin: 0 auto;
  padding-bottom: 50px;
  position: relative;
  width: 100%;
}

.list-wrap {
  background: #eeeef3;
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  line-height: 20px;
  margin: 30px auto 0px auto;
  width: 1121px;
}

.list-item {
  background-color: #ffffff;
  border-radius: 0 35px 0 35px;
  box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  height: 400px;
  margin: 0 32px 78px 0;
  position: relative;
  vertical-align: top;
  width: 338px;
}

/*.list-item:nth-child(3n){
  margin: 0 0 78px 0;
}*/

.list-item div {
  color: #000000;
  display: block;
  font-family: "Gotham", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  margin: 30px;
  min-height: 53px;
  padding-right: 25%;
}

.list-item p {
  color: #000000;
  font-family: GothamBook, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin: 0 30px;
  min-height: 78px;
  line-height: 17px;
}

.list-item .button {
  background: rgb(26, 64, 132);
  background: linear-gradient(90deg, rgba(26, 64, 132, 1) 0%, rgba(84, 51, 143, 1) 80%, rgba(84, 51, 143, 1) 100%);
  border-radius: 0 0 0 35px;
  border: 0px;
  height: 70px;
  border-top: 4px solid #1c75bc;
  bottom: 0px;
  color: #ffffff;
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 60px;
  margin: 0;
  padding: 0 70px 0 0;
  position: absolute;
  text-align: right;
  text-decoration: none;
  width: calc(100% - 70px);
}

.list-item .button img {
  position: absolute;
  top: 14px;
  right: 15px;
}

.list-item .button.visit {
  background: rgb(21, 129, 198);
  background: linear-gradient(90deg, rgba(21, 129, 198, 1) 0%, rgba(2, 164, 226, 1) 100%);
  border-top-color: #00467e;
}

.pdf-icon {
  background: url(../img/pdf-icon.png) no-repeat top right;
}

.xls-icon {
  background: url(../img/xls-icon.png) no-repeat top right;
}

.ppt-icon {
  background: url(../img/ppt-icon.png) no-repeat top right;
}

.web-icon {
  background: url(../img/web-icon.png) no-repeat top right;
}

.xls-icon {
  background: url(../img/xls-icon.png) no-repeat top right;
}

.doc-icon {
  background: url(../img/doc-icon.png) no-repeat top right;
}

.list-item a.no-icon {
  padding-right: 0;
}

.video-thumb {
  cursor: pointer;
  margin-top: 11px !important;
  width: 100%;
}

.filters-wrap {
  display: block;
  margin: 0 auto;
  min-height: 56px;
  margin-bottom: 30px;
  position: relative;
  width: 1121px;
}

.filter-button {
  background: rgb(21, 128, 197);
  background: linear-gradient(90deg, rgba(21, 128, 197, 1) 0%, rgba(3, 165, 227, 1) 100%);
  border-radius: 0 0 0 35px;
  bottom: 0px;
  color: #ffffff;
  cursor: pointer;
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  height: 55px;
  font-weight: bold;
  line-height: 55px;
  position: absolute;
  width: 382px;
  z-index: 100;
}

.filter-button img {
  float: left;
  margin: 11px 23px 0 28px;
}

.filter-content {
  background-color: #ffffff;
  border-radius: 0 0 0 40px;
  left: 0;
  padding-top: 75px;
  position: absolute;
  width: 382px;
  z-index: 10;

}

.filter-content.show {
  display: block;
}

.filter-head {
  border-bottom: 1px solid #d0d0d0;
  color: #31598A;
  line-height: 53px;
  margin: 0 27px;
  padding-left: 55px;
  height: 53px;
  width: calc(100% - 109px);
}

.filter-list {
  margin: 0 27px;
}

.filter-list input[type="checkbox"] {
  -webkit-appearance: none;
  appearance: none;
  background-color: #ffffff;
  border: solid 1px #c3c3c3;
  box-sizing: border-box;
  cursor: default;
  float: left;
  height: 31px;
  margin: 0 24px 0 0;
  padding: initial;
  width: 31px;
}

.filter-list input[type="checkbox"]:checked {
  background: url(../img/icon-check.png) no-repeat center center;
}

.filter-list input[type="checkbox"]:focus {
  outline-width: 0;
}

.filter-list p {
  color: #898989;
  font-size: 20px;
  line-height: 24px;
  margin: 38px 0;
  min-height: 31px;
}

.filter-list span {
  display: flex;
}

.filter-list:nth-child(3n) {
  color: #ff0000;
}

.filter-list:nth-child(3n) span,
.filter-list:nth-child(4n) span {
  position: relative;
  top: -10px;
}

.filter-content #apply {
  width: 100%;
  border: 0;
}

.filter-content .apply {
  background: rgb(1, 168, 229);
  background: linear-gradient(90deg, rgba(1, 168, 229, 1) 0%, rgba(27, 117, 188, 1) 80%, rgba(27, 117, 188, 1) 100%);
  border-radius: 0 0 0 40px;
  color: #ffffff;
  cursor: pointer;
  font-size: 22px;
  line-height: 55px;
  height: 55px;
  text-align: center;
  width: 100%;
}

#filter-ckeck {
  width: 382px;
  height: 55px;
  position: absolute;
  cursor: pointer;
  opacity: 0;
  left: -5px;
  top: -1px;
  z-index: 100000;
}

.applied-filters {
  color: #000000;
  display: block;
  font-family: GothamBook, sans-serif;
  font-weight: 400;
  line-height: 50px;
  margin: 0 auto;
  width: 1121px;
}

.applied-filters-list {
  display: block;
  height: auto;
  line-height: 40px;
}

.applied-filters-list>div {
  background: #ffffff url(../img/icon-list-close.png) no-repeat 20px center;
  border-radius: 25px;
  box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  font-weight: 800;
  height: 52px;
  line-height: 52px;
  margin: 0 20px 30px 0;
  padding: 0 25px 0 5px;
}

.applied-filters-list>div input {
  cursor: pointer;
  height: 30px;
  margin: 0 0 0 15px;
  opacity: 0;
  vertical-align: middle;
  width: 30px;
}



.home-body {
  display: block;
  font-family: acumin-pro, sans-serif;
  font-size: 14px;
  margin: 59px auto 0 auto;
  width: 1110px;
}



.resources {
  display: block;
  margin: 80px auto;
  width: 1187px;
}

.resources>div {
  padding-left: 16px;
  vertical-align: top;
  width: 277px;
}

.resources>div:first-child {
  padding-left: 0px;
}

.resources>div:last-child .resource_info_wrap {
  border: 0;
}

.resources .resource_info_wrap {
  border-right: 1px solid #667f9d;
  margin: 0 15px 25px 0;
  padding-right: 16px;
  text-align: center;
  width: calc(100% - 16px);
}

.resources>div h3 {
  color: #1c75bc;
  height: 60px;
  margin: 25px auto 0 auto;
  width: 140px;
}

.top-link {
  background: url(../img/icon-backToTop.png) no-repeat center right;
  bottom: 35px;
  color: #A65103;
  font-family: GothamMedium, sans-serif;
  font-size: 18px;
  position: absolute;
  right: 115px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  line-height: 42px;
  padding-right: 56px;
}

strong {
  font-weight: bold;
}

.video-wrapper {
  background-color: #ffffff;
  bottom: 20%;
  display: inline-table;
  margin: auto 22%;
  padding: 20px 48px 48px 48px;
  position: fixed;
  height: 400px;
  width: 635px;
  top: 20%;
  z-index: 11100;
}

.video-wrapper .video-title {
  color: #1b4084;
  font-family: GothamBook, sans-serif;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 25px;
}

.video-wrapper .video-tag {
  width: 100%;
}

.video-wrapper .video-close {
  background: url(../img/close-video.jpeg) no-repeat center right;
  cursor: pointer;
  font-size: 0;
  height: 25px;
  margin: 7px 25px 0 0;
  position: absolute;
  right: 0;
  width: 25px;
}

.video-wrapper video {
  width: 100%;
}

.overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11000;
  cursor: pointer;
}

.empty-message {
  padding-bottom: 50px;
  width: 80%;
}

/*max-width 1230px*/
@media screen and (max-width: 1230px) {
  footer img {
    left: 78%;
  }

  .top-banner *,
  .body * {
    max-width: 95%;
  }

  .bottom-banner,
  .list-wrap,
  .home-body {
    width: 90%;
  }

  .list-wrap {
    margin-bottom: 50px;
  }

  .filters-wrap,
  .applied-filters {
    width: 90%;
  }

  .list-item {
    margin: 0 38px 60px 0;
    text-align: left;
  }

  .empty-message {
    padding-bottom: 50px;
    width: 80%;
  }

}

/*max-width 1024px*/
@media screen and (max-width: 1024px) {

  .list-wrap,
  .home-body {
    width: 75%;
  }

  .video-wrapper {
    margin: auto 12%;
  }
}

/*between 881px and 1024px*/
@media screen and (min-width: 881px) and (max-width: 1024px) {

  .list-wrap,
  .home-body {
    width: 86%;
  }
}

/*max-width 880px*/
@media screen and (max-width: 880px) {

  .top-banner {
    background: url(../img/banner-mobile4-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  .top-banner section {
    font-family: GothamBook, sans-serif;
    font-size: 28px;
    line-height: 30px;
    width: 86%;
  }

  .top-banner section p {
    margin: 23px 0;
  }

  .top-content p.banner-footer {
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }

  .resources {
    margin: 80px auto 0 auto;
    width: 80%;
  }

  .resources>div {
    padding-left: 0;
    margin-right: 28px;
    margin-bottom: 70px;
    width: 297px;
  }

  .resources div:nth-child(2n) {
    margin-right: 0;
    width: 260px;
  }

  .resources div:nth-child(2n) .resource_info_wrap {
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources .resource_info_wrap {
    margin: 0 37px 25px 0;
    padding-right: 0px;
    width: 100%;
  }

  .home-body {
    width: 87%;
  }

  .top-banner h2 {
    width: 96%;
  }

  .bottom-banner {
    padding-left: 60px;
    padding-right: 60px;
    width: calc(100% - 120px);
  }

  .step-item-desc-wrap {
    width: 95%;
  }

  .step-item {
    text-align: center;
  }

  .step-circle {
    margin: 60px 0 45px 0;
  }

  .step-item-desc-wrap {
    text-align: left;
  }

  .list-wrap {
    width: 88%;
  }

  .list-item {
    margin-right: 38px;
    width: 300px;
  }

  .list-item .button {
    width: 230px;
    background-size: contain;
  }

  .body {
    width: 90%;
  }

  .body .subhead {
    width: 100%;
  }

  .body-list-wrap,
  .body .references,
  .body-list-item button,
  .body-list-item .button {
    width: 100%;
  }

  .body-list-item {
    margin-right: 37px;
    width: 300px;
  }

  .list-item:nth-child(3n) {
    margin: 0 32px 78px 0;
  }

  .list-item:nth-child(2n) {
    margin: 0 0 78px 0;
  }

  .body-list-item:nth-child(2n) {
    margin: 0;
  }

  .body-list-item:nth-child(3n) {
    margin: 0 32px 78px 0;
  }

  .list-content .subhead,
  .list-content .subhead-description {
    padding-left: 37px;
    padding-right: 37px;
    width: calc(100% - 74px);
  }

  .filters-wrap {
    margin: 0 37px;
    width: calc(100% - 74px);
  }

  .filter-content,
  .applied-filters {
    width: 100%;
  }

  .filter-content {
    border-radius: 0 0 0 35px;
    box-shadow: -10px -10px 30px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: -10px -10px 30px 0px rgba(0, 0, 0, 0.15);
    -webkit-box-shadow: -10px -10px 30px 0px rgba(0, 0, 0, 0.15);
  }

  #filter-ckeck {
    width: 100%;
    height: 55px;
    position: absolute;
    cursor: pointer;
    opacity: 0;
    right: -5px;
    top: -1px;
    z-index: 100000;
  }

  .filter-button {
    background: rgb(21, 128, 197);
    background: linear-gradient(90deg, rgba(21, 128, 197, 1) 0%, rgba(3, 165, 227, 1) 100%);
    border-radius: 0 0 0 35px;
    bottom: 0px;
    color: #ffffff;
    font-family: "GothamBook", sans-serif;
    font-size: 15px;
    height: 55px;
    font-weight: bold;
    line-height: 55px;
    position: absolute;
    width: 100%;
  }

  .filter-content input {
    -webkit-appearance: none;
    appearance: none;
  }

  .filter-button img {
    float: left;
    margin: 11px 23px 0 28px;
  }

  .applied-filters-list,
  .applied-label {
    padding: 0 37px;
  }

  .filter-content .apply {
    border-radius: 0;
    margin: 0 27px 45px 27px;
    width: calc(100% - 52px);
  }

  .top-link {
    right: 35px;
  }

  .video-wrapper {
    background-color: #ffffff;
    bottom: 20%;
    display: inline-table;
    margin: auto 1%;
    padding: 20px 5% 20px 5%;
    position: fixed;
    height: 265px;
    width: 88%;
    top: 20%;
    z-index: 11100;
  }

  .video-wrapper .video-title {
    color: #1b4084;
    font-family: GothamBook, sans-serif;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  .video-wrapper .video-tag {
    width: 100%;
  }

  .video-wrapper .video-close {
    background: url(../img/close-video.jpeg) no-repeat center right;
    cursor: pointer;
    font-size: 0;
    height: 25px;
    margin: 7px 25px 0 0;
    position: absolute;
    right: 0;
    width: 25px;
  }

  .video-wrapper video {
    width: 100%;
  }

  #playVideos {
    height: 210px !important;
  }


  .video-thumb img {
    width: 83%;
  }

  .empty-message {
    padding-bottom: 50px;
    width: 80%;
  }

  .applied-filters-list {
    margin-top: 30px;
  }

  .empty-message {
    padding-bottom: 50px;
  }

}

/*max-width 415px*/
@media screen and (max-width: 415px) {

  .resources .resource_info_wrap {
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources div a {
    display: block;
    height: 55px;
  }

  .resources>div button {
    width: 100%;
  }

  .resources>div,
  .resources div:nth-child(2n) {
    width: 100%;
  }

  .top-banner sup {
    font-size: 9px;
  }

  .bottom-banner {
    padding-left: 30px;
    padding-right: 30px;
    width: calc(100% - 60px);
  }

  .list-wrap {
    text-align: center;
  }

  .list-item {
    margin: 0 0 60px 0;
  }

  .top-banner section {
    font-size: 23px;
  }

  .body {
    width: 86%;
  }

  .body-list-item,
  .body-list-item:nth-child(2n),
  .body-list-item:nth-child(3n),
  .list-item:nth-child(2n),
  .list-item:nth-child(3n) {
    margin: 0 0 60px 0;
  }

  .applied-filters-list>div {
    font-size: 12px;
    margin: 0 0 30px 0;
    width: 90%;
  }

  .applied-filters-list>div input {
    margin: 0 0 0 8px;
  }

  .top-content {
    padding-bottom: 28px;
  }

  .top-banner {
    min-height: 184px;
  }

  .top-banner h1 {
    font-size: 18px;
    line-height: 23px;
    margin: 40px auto 20px auto;
  }

  .empty-message {
    padding-bottom: 50px;
  }
}

/* new styles sergio */
@media screen and (max-width: 880px) {

  .home a {
    background-size: 38px auto;
  }

  .population-identification {
    background-size: 37px auto;
  }

  .expanding-capabilities,
  .collaborative-care {
    background-size: 35px auto;
  }

  .process-evaluation,
  .resource-library {
    background-size: 31px auto;
  }

  .site-guide {
    background-size: 33px auto;
  }

  .top-banner header .logo img {
    width: 60%;
  }
}

@media screen and (max-width: 415px) {

  .empty-message {
    padding-bottom: 50px;
  }

  @supports (-webkit-touch-callout: none) {
    .filter-list span {
      line-height: 32px;
    }

    .filter-content .apply {
      line-height: 70px;
    }

    .top-link {
      padding-top: 12px;
    }

  }

  .filters-wrap {
    margin: 0;
    width: 100%;
  }

  .list-wrap {
    width: 100%;
  }

  .video-wrapper .video-close {
    margin: 0px 15px 0 0;
  }

  .video-wrapper .video-title {
    max-width: 240px;
    margin-bottom: 10px;
  }


}

@media screen and (orientation:portrait) {
  .video-wrapper {
    top: 25%;
  }
}

@media screen and (orientation:landscape) and (max-height: 736px) and (max-width: 1000px) {
  .video-wrapper {
    max-height: 100%;
    margin: 0 8%;
    width: 480px;
    top: 25%;
  }

  .list-wrap {
    text-align: center;
  }
}

@media screen and (orientation:landscape) and (max-width: 668px) {

  .list-wrap {
    text-align: center;
  }

  .list-wrap .list-item {
    margin-right: 0;
  }
}

@media screen and (orientation:landscape) and (max-height: 360px) {
  .video-wrapper {
    max-height: 100%;
    margin: 0 10%;
    width: 391px;
    top: 0%;
  }
}

#filters {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Resource_Library.vue